import { createGlobalStyle } from 'styled-components';
import { plexMonoFontFace } from './fonts.cp';

// Глобальные стили (CP-редизайн дизайн), подключаются через libs/design
export const GlobalDesignStyle = createGlobalStyle`
${plexMonoFontFace}
body {
  height: 100vh;
  width: 100vw;
  font-family: 'IBM Plex Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif;
  margin: 0;
  padding: 0;
  background-color: #0e1518;
  color: #e6eaec;
  overflow: hidden;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* шрифт задаётся один раз на body; нативные контролы по умолчанию его не наследуют */
button,
input,
select,
textarea {
  font-family: inherit;
}

/* CleverParking brand scrollbar */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}
::-webkit-scrollbar-thumb {
  background: #3a444b;
  border-radius: 4px;
}
::-webkit-scrollbar-thumb:hover {
  background: #7a838a;
}
::-webkit-scrollbar-track {
  background: transparent;
}

.main {
  transform: scale(0.9);
}

input[disabled] {
  pointer-events: none;
}

.loading {
  position: relative;
}
.loading::after {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  /* z-index: 9999; */
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.7) url(images/loader2.svg) no-repeat 50% 50%;
  background-size: 20px;
}
.loading.simple::after {
  background-color: transparent;
}

.react-notification-root {
  z-index: 90000 !important;
}

/* ==== CleverParking toast notifications ============================== */
.notification-item {
  border-radius: 12px !important;
  border: none !important;
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.5) !important;
  font-family: inherit !important;
  background-color: #161e23 !important;
  border-left: 4px solid #47b972 !important;
}
.notification-item .notification-title {
  color: #e6eaec !important;
  font-weight: 600 !important;
  font-size: 14px !important;
}
.notification-item .notification-message {
  color: #aab2b8 !important;
  font-size: 13px !important;
}
.notification-item .notification-content {
  padding: 12px 14px !important;
}
.notification-item .notification-close {
  background-color: rgba(255, 255, 255, 0.16) !important;
}
.notification-item .notification-close:hover {
  background-color: rgba(255, 255, 255, 0.32) !important;
}
.notification-item .timer {
  background-color: rgba(255, 255, 255, 0.08) !important;
}
.notification-item .timer-filler {
  background-color: #47b972 !important;
}
.notification-success {
  background-color: #16261d !important;
  border-left-color: #47b972 !important;
}
.notification-danger {
  background-color: #271519 !important;
  border-left-color: #cc2936 !important;
}
.notification-warning {
  background-color: #262219 !important;
  border-left-color: #d4a017 !important;
}
.notification-info {
  background-color: #161e23 !important;
  border-left-color: #47b972 !important;
}
.notification-info .notification-close {
  background-color: rgba(255, 255, 255, 0.16) !important;
}
.notification-info .timer {
  background-color: rgba(255, 255, 255, 0.08) !important;
}

/* ==== CleverParking native form controls (dark) ======================
   Mirrors caps-crm cp-global.js so selects / checkboxes / radios / inputs
   inside the modal windows read on-brand (green accents, no legacy blue). */
input[type='radio'] {
  accent-color: #47b972;
}

/* CP custom checkbox — dark box, green check (skips the .toggle-input switches) */
input[type='checkbox']:not(.toggle-input) {
  -webkit-appearance: none;
  appearance: none;
  box-sizing: border-box;
  width: 18px;
  height: 18px;
  margin: 0;
  border: 1px solid #3d4952;
  border-radius: 5px;
  background: #1a2429;
  cursor: pointer;
  position: relative;
  flex-shrink: 0;
  vertical-align: middle;
  transition: background 0.15s ease, border-color 0.15s ease;
}
input[type='checkbox']:not(.toggle-input):hover {
  border-color: #47b972;
}
input[type='checkbox']:not(.toggle-input):checked {
  background-color: #47b972;
  border-color: #47b972;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath fill='none' stroke='white' stroke-width='2.3' stroke-linecap='round' stroke-linejoin='round' d='M3.5 8.5l3 3 6-6.5'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: center;
  background-size: 78%;
}

/* Native <select> — consistent chevron pinned to the end, green accent */
select {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  accent-color: #47b972;
  background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'><path fill='none' stroke='%23aab2b8' stroke-width='1.6' stroke-linecap='round' stroke-linejoin='round' d='M4 6l4 4 4-4'/></svg>");
  background-repeat: no-repeat;
  background-position: right 9px center;
  background-size: 14px;
  padding-right: 28px;
  text-overflow: ellipsis;
}
select option {
  background-color: #161e23;
  color: #e6eaec;
}
select option:checked,
select option:hover {
  background: #47b972;
  color: #ffffff;
}

/* Text-like fields: green focus ring inside windows */
input:not([type='checkbox']):not([type='radio']):focus,
select:focus,
textarea:focus {
  border-color: #47b972 !important;
  box-shadow: 0 0 0 3px rgba(71, 185, 114, 0.14);
  outline: none;
}

/* ==== CleverParking rc-calendar (date picker popup) ================= */
.rc-calendar,
.rc-calendar.calendar {
  width: 302px !important;
  background: transparent !important;
  border: 0 !important;
  box-shadow: none !important;
  font-family: inherit !important;
  color: #e6eaec !important;
}
/* the actual visible surface — solid dark, soft rounded */
.rc-calendar-date-panel,
.rc-calendar-panel,
.rc-calendar-month-panel,
.rc-calendar-year-panel,
.rc-calendar-decade-panel {
  background: #161e23 !important;
  border: 1px solid #3d4952 !important;
  border-radius: 14px !important;
  box-shadow: 0 16px 38px rgba(0, 0, 0, 0.6) !important;
  overflow: hidden;
}
/* make the date panel flow normally as a clean dropdown (base css absolutely
   positions it with an invalid 'right:1', which threw it off-screen) */
.rc-calendar-date-panel {
  position: relative !important;
  right: auto !important;
  top: auto !important;
  width: 302px !important;
}
.rc-calendar-header,
.rc-calendar-body,
.rc-calendar-footer,
.rc-calendar-month-panel-body,
.rc-calendar-year-panel-body,
.rc-calendar-decade-panel-body {
  background: transparent !important;
}
.rc-calendar-time-picker,
.rc-calendar-time-picker-panel,
.rc-calendar-time-picker-inner {
  background: #161e23 !important;
}
.rc-calendar-header,
.rc-calendar-month-panel-header,
.rc-calendar-year-panel-header,
.rc-calendar-decade-panel-header {
  border-bottom: 1px solid #2c353d !important;
  color: #e6eaec !important;
}
.rc-calendar-header a,
.rc-calendar-my-select,
.rc-calendar-header .rc-calendar-century-select,
.rc-calendar-header .rc-calendar-decade-select,
.rc-calendar-header .rc-calendar-year-select,
.rc-calendar-header .rc-calendar-month-select {
  color: #e6eaec !important;
}
.rc-calendar-column-header .rc-calendar-column-header-inner {
  color: #7a838a !important;
}
.rc-calendar-date {
  color: #e6eaec !important;
  border-radius: 7px !important;
  border: 1px solid transparent !important;
}
.rc-calendar-date:hover {
  background: #232e35 !important;
  color: #e6eaec !important;
}
.rc-calendar-today .rc-calendar-date {
  border-color: #47b972 !important;
  color: #5cc98a !important;
}
.rc-calendar-selected-day .rc-calendar-date,
.rc-calendar-selected-date .rc-calendar-date,
.rc-calendar-selected-start-date .rc-calendar-date,
.rc-calendar-selected-end-date .rc-calendar-date {
  background: #47b972 !important;
  color: #ffffff !important;
  border-color: #47b972 !important;
}
.rc-calendar-last-month-cell .rc-calendar-date,
.rc-calendar-next-month-btn-day .rc-calendar-date {
  color: #4b565e !important;
}
.rc-calendar-footer {
  border-top: 1px solid #2c353d !important;
}
.rc-calendar-today-btn,
.rc-calendar-time-picker-btn {
  color: #5cc98a !important;
}
.rc-calendar-today-btn:hover,
.rc-calendar-time-picker-btn:hover {
  color: #47b972 !important;
}
.rc-calendar-ok-btn {
  background: #47b972 !important;
  border-color: #47b972 !important;
  color: #ffffff !important;
  border-radius: 8px !important;
}
.rc-calendar-ok-btn:hover {
  background: #3aa863 !important;
  border-color: #3aa863 !important;
}
.rc-calendar-prev-month-btn,
.rc-calendar-next-month-btn,
.rc-calendar-prev-year-btn,
.rc-calendar-next-year-btn {
  color: #aab2b8 !important;
}
.rc-calendar-input,
.rc-calendar-input-wrap {
  background: #1a2429 !important;
  color: #e6eaec !important;
  border-color: #3d4952 !important;
}
.rc-calendar-time-picker-inner,
.rc-calendar-time-picker-select {
  background: #161e23 !important;
  color: #e6eaec !important;
}
.rc-calendar-time-picker-select li:hover {
  background: #232e35 !important;
}
.rc-calendar-time-picker-select li.rc-calendar-time-picker-select-option-selected {
  background: #47b972 !important;
  color: #ffffff !important;
}/* rc-time-picker Panel (колонки часы/минуты внутри rc-calendar) */
.rc-time-picker-panel,
.rc-time-picker-panel-inner,
.rc-time-picker-panel-combobox,
.rc-time-picker-panel-select {
  background: #161e23 !important;
  color: #e6eaec !important;
  border-color: #2c353d !important;
  box-shadow: none !important;
}
.rc-time-picker-panel-input-wrap {
  background: #161e23 !important;
  border-bottom: 1px solid #2c353d !important;
}
.rc-time-picker-panel-input {
  background: #1a2429 !important;
  color: #e6eaec !important;
}
.rc-time-picker-panel-select {
  border-left: 1px solid #2c353d !important;
}
.rc-time-picker-panel-select:first-child {
  border-left: 0 !important;
}
.rc-time-picker-panel-select li {
  color: #aab2b8 !important;
  background: transparent !important;
}
.rc-time-picker-panel-select li:hover {
  background: #232e35 !important;
  color: #e6eaec !important;
}
li.rc-time-picker-panel-select-option-selected,
li.rc-time-picker-panel-select-option-selected:hover {
  background: #47b972 !important;
  color: #ffffff !important;
  font-weight: 600 !important;
}
li.rc-time-picker-panel-select-option-disabled {
  color: #4a555c !important;
}
.rc-time-picker-panel-select ul {
  scrollbar-color: #3a444b transparent;
}
`;
